import {
  fetchItineraryDetailsFailed,
  fetchItineraryDetailsSuccess,
  fetchItineraryDetailsInvoked,
  ITINERARYDETAILS_FETCH_DATA,
  ITINERARYDETAILS_FETCH_DATA_CUSTOM_DATES,
} from "src/redux/actions/itineraryDetails";
import { put, call, select, takeEvery } from "redux-saga/effects";
import {
  fetchData,
  fetchDataWithCustomDates,
  getTravelerTrackerProperties,
} from "src/services/itineraryDetails";
import { getStatuses } from "src/redux/actions/travelerTracker";
import { Timeframes } from "src/pages/TravelerTracker/TimeRange";
import { WidgetI } from "src/types/Widget";

function getWidgets(state) {
  return state.widgets;
}

function* fetchItineraryDetails({
  timeFrames,
  id,
}: {
  timeFrames: Timeframes;
  id: string;
  type: string;
}) {
  try {
    yield put(fetchItineraryDetailsInvoked(id));
    const widgets: WidgetI[] = yield select(getWidgets);
    const properties = getTravelerTrackerProperties(widgets, id);
    if (timeFrames) properties.timeFrames = timeFrames;
    const { itineraries, showDebtorName } = yield call(fetchData, {
      timeFrames: properties.timeFrames,
      id,
    });
    yield put(fetchItineraryDetailsSuccess(itineraries, id, showDebtorName));
    yield put(getStatuses(id));
  } catch (ex) {
    yield put(fetchItineraryDetailsFailed(ex, id));
  }
}

function* fetchItineraryDetailsCustomDates({
  startDate,
  endDate,
  id,
}: {
  startDate: moment.Moment;
  endDate: moment.Moment;
  id: string;
  type: string;
}) {
  try {
    yield put(fetchItineraryDetailsInvoked(id));
    const { itineraries, showDebtorName } = yield call(fetchDataWithCustomDates, {
      startDate,
      endDate,
      id,
    });
    yield put(fetchItineraryDetailsSuccess(itineraries, id, showDebtorName));
    yield put(getStatuses(id));
  } catch (ex) {
    yield put(fetchItineraryDetailsFailed(ex, id));
  }
}

function* itinerariesSaga() {
  yield takeEvery(ITINERARYDETAILS_FETCH_DATA, fetchItineraryDetails);
  yield takeEvery(
    ITINERARYDETAILS_FETCH_DATA_CUSTOM_DATES,
    fetchItineraryDetailsCustomDates
  );
}

export default itinerariesSaga;
